import validator from 'validator';
import i18n from "shared/i18n";

const validate = (socialNetworksList, type, name, value, executedFunction = null) => {
  let errors = null;

  // VALIDATION
  if (value) {
    // Email validation
    if (type === 'email') {
      if (!validator.isEmail(value) || /\s/.test(value)) {
        errors = i18n.t("Please enter a valid email address");
      }
    }

    // URL
    if (type === 'url') {
      if (!validator.isURL(value, { allow_underscores: true }) || /\s/.test(value)) {
        errors = i18n.t("Please enter a valid link");
      }

      socialNetworksList && socialNetworksList.forEach(item => {
        if (
          item.name.toLowerCase() === name &&
          !value.includes(item.url_validation)
        ) {
          errors = i18n.t("Please enter a valid link");
        }
      });
    }

    // Username or Handle values detection
    if (type === 'handle' && /\s/.test(value)) {
      errors = i18n.t("Please enter a valid username or handle");
    }

    // WhatsApp
    if (name === 'whatsapp') {
      if ((!/^(\+*)\d{8,}$/.test(value) && !validator.isEmpty(value)) || /\s/.test(value)) {
        errors = i18n.t("Please enter a valid WhatsApp mobile number");
      }
    }

    // Viber
    if (name === 'viber') {
      if ((!/^(\+*)\d{8,}$/.test(value) && !validator.isEmpty(value)) || /\s/.test(value)) {
        errors = i18n.t("Please enter a valid Viber mobile number");
      }
    }

    // Signal
    if (name === 'signal') {
      if ((!/^(\+*)\d{8,}$/.test(value) && !validator.isEmpty(value)) || /\s/.test(value)) {
        errors = i18n.t("Please enter a valid Signal mobile number");
      }
    }
  }

  // EXECUTE FUNCTION
  if (!errors && executedFunction) {
    executedFunction();
    return null;
  }

  return errors;
};

export default validate;
